import { Injectable } from '@angular/core'
import { nginV2Headers } from '@se-po/shared-data-access-models'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { SeFeApiService } from 'se-fe-api'
import { ApiResponse } from 'se-resource-types/dist/lib/common'
import { SurveyResult } from 'se-resource-types/dist/lib/Ngin'

type FindMineParams = Record<string, string | number | boolean>

export interface SurveyResultFilterOption {
  id: string
  name: string
}

export interface SurveyResultMineFacets {
  sports: SurveyResultFilterOption[]
  organizations: SurveyResultFilterOption[]
  signup_types: SurveyResultFilterOption[]
  people: SurveyResultFilterOption[]
}

@Injectable({
  providedIn: 'root'
})
export class SurveyResultService {

  private endpoint = 'survey_results'

  constructor(
    private api: SeFeApiService
  ) { }

  public findByPersonaId(personaId: string | number, perPage=100, params={}): Observable<SurveyResult[]> {
    return this.api.get<SurveyResult[]>(`${this.endpoint}?persona_id=${personaId}&per_page=${perPage}`, { params, headers: nginV2Headers })
      .pipe(map(response => response.result))
  }

  public findMine(params: FindMineParams = {}): Observable<SurveyResult[]> {
    return this.findMineResponse(params).pipe(map(response => response.result))
  }

  public findMineResponse(params: FindMineParams = {}): Observable<ApiResponse<SurveyResult[]>> {
    const defaults = { page: 1, per_page: 1000 }

    return this.getMine({ ...defaults, ...params })
  }

  public findMineFacets(params: FindMineParams = {}): Observable<SurveyResultMineFacets> {
    return this.api.get<SurveyResultMineFacets>(
      `${this.endpoint}/mine/facets`,
      { params, headers: nginV2Headers }
    ).pipe(map(response => response.result))
  }

  private getMine(params: FindMineParams): Observable<ApiResponse<SurveyResult[]>> {
    return this.api.get<SurveyResult[]>(
      `${this.endpoint}/mine`,
      { params, headers: nginV2Headers }
    )
  }

}
